import axios from 'axios';
import { storeActiveDepartment } from '@/services';

export default {
  namespaced: true,
  state: {
    pending: false,
    resetPasswordDetails: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      acceptConditions: false
    }
  },
  mutations: {
    setResetPasswordDetails(state, payload) {
      state.resetPasswordDetails[payload.key] = payload.value;
    }
  },
  actions: {
    selectedDepartmentChange({ commit }, value) {
      storeActiveDepartment(value);
    },
    submitCreateFirstPasswordForm({ commit, state }) {
      return axios.post('Password/ChangePassword', state.resetPasswordDetails);
    },
    submitResetPasswordForm({ commit, state }, data) {
      // Submit the request to reset ones password
      return axios.post('Password/SendValidationEmail', data);
    },
    validateSetPasswordToken({ commit, state }, data) {
      // Before choosing a new password, check whether e-mail token querystring is valid (on app load)
      // return new Promise((resolve, reject) => { resolve() })
      return axios.post('Password/CheckValidationToken', data);
    },
    submitSetPasswordForm({ commit, state }, data) {
      // Submit final request to set a new password
      return axios.post('Password/ResetPassword', data);
    }
  },
  getters: {
    getIsPending: (state) => {
      return state.pending;
    },
    getResetPasswordDetails: (state) => {
      return state.resetPasswordDetails;
    }
  }
};
